<template>
  <div class="travelBx">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="工作流说明" name="1">
        <div class="workflow" v-if="workflow == 0">
          <div>
            1、工作流适用范围：用于员工因公市外出差前的申请，没有此申请不予报销出差费用。
          </div>
          <div>2、申请金额必须符合差旅费管理制度的费用标准。</div>
          <div>
            3、自驾车出行的，不得超过同类型高铁或动车二等座或者普通客运标准。
          </div>
          <div>
            4、住宿酒店必须取得住宿清单和合规发票，对于无法提供住宿清单的，也请酒店出具收条，标明住宿具体信息。
          </div>
          <div>
            5、工作流所需附件:<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >出差申请-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 1">
          <div>
            1、工作流适用范围：员工个人因公差旅发生的各类交通、住宿等费用报销；包括培训、招聘产生的差旅费用。
          </div>
          <div>2、报销金额应小于等于申请金额，否则退回。</div>
          <div>
            3、
            实际报销费用总额超过差旅费管理制度所列标准的，需关联《差旅费超标审批》流程。
          </div>
          <div>
            4、住宿费用须取得盖章的费用清单和合规发票。无法提供费用清单的，需由酒店提供住宿盖章费用证明。
          </div>
          <div>5、自驾出行按照相关标准报销，可使用燃油、路桥、停车费发票。</div>
          <div>6、所有费用均需提供发票，不允许使用替票。</div>
          <div>7、具体请参阅《差旅费管理制度》。</div>
          <div>
            8、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >出差费用报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 2">
          <div>1、工作流适用范围：工作地所在地、县、市外勤的交通费用报销。</div>
          <div>
            2、市内交通费上限40元/天，额度内实报实销；享受车补人员不得报销市内交通费。
          </div>
          <div>3、自驾车出行的按月汇总报销，其中燃油费不超过300元/月</div>
          <div>
            4、发票类型：公交、地铁、出租车等公共交通发票，网约车发票和对应行程单，自驾车燃油和路桥发票。
          </div>
          <div>5、推荐和提倡月度汇总报销。</div>
          <div>6、具体请参阅《差旅费管理制度》。</div>
          <div>
            7、工作流所需附件:<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >市内出差报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 3">
          <div>
            1、工作流适用范围：日常零星费用报销及对公支付，需选择以下对应的具体费用类型：
          </div>
          <div>
            &emsp;①行政后勤费用，包括办公用品采购、办公费用、低值办公设施、零星修理费、物业费、水电费、保洁费、零星消防用品、其他后勤费用等；
          </div>
          <div>&emsp;②安全相关的费用</div>
          <div>&emsp;③商务车相关费用</div>
          <div>&emsp;④培训费及招聘费用（除差旅之外）</div>
          <div>
            &emsp;⑤营运类费用：包括叉车使用费、专用工具、装卸费等小额零星发生费用。
          </div>
          <div>
            2、行政事业性收费、公共事业性费用（如，水电费、通讯费、垃圾清运费、卫生费及其他物业费、地区性供暖、通讯费等，需选择“是否行政事业性费用或通讯费”。
          </div>
          <div>3、票据要求：</div>
          <div>
            &emsp;①原则上所有费用均应提供合规发票、或合规的行政事业性收费凭证；
          </div>
          <div>
            &emsp;②500元以下无法取得合规发票，可提供收款人身份证复印件以及收款人签收证明。
          </div>
          <div>
            4、所有费用除发票外，需据实际情况提供合同、各类清单、订单等其他证明费用真实性、相关性附件。
          </div>
          <!-- <div>
            5、一笔费用涉及多部门分摊的，拆分成多行明细填写，每行费用对应一个预算单位。
          </div> -->
          <div>
            5、除行政事业性收费、公共事业性收费外，单笔费用大于2000元的需关联相应费用申请（采购申请-分散采购、采购申请、培训计划申请）。
          </div>
          <div>
            6、工作流所需附件:<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >零星费用报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 4">
          <div>
            1、工作流适用范围：出差费用报销的任意一项费用金额高于差旅费管理制度对应标准的。
          </div>
          <div>
            2、工作流所需附件:<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >差旅超标申请-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 5">
          <div>
            1、工作流适用范围：公司经营管理中用于接待应酬的各项费用，其开支项目主要包括：接待、宴请和赠送礼品、宣传用品等。
          </div>
          <div>
            2、填报要求：①招待性质（公务/商务/外事）②招待单位简称③招待人数及陪同人数（陪同人数不超过30%）。
          </div>
          <div>
            3、报销标准：公务用餐标准人均不超225元，商务和外事用餐标准人均不超过600元，工作客饭标准人均不超过50元。
          </div>
          <div>4、业务招待费不得用于本公司职工招待。</div>
          <div>
            5、单笔在2000元（不含）以上的业务招待费须预先审批，并上传附件。
          </div>
          <div>6、具体请参阅《业务招待费管理办法》</div>
          <div>
            7、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >业务招待费报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 6">
          <div>工作流说明:</div>
          <div>1、工作流适用范围：员工在额度内报销的通讯费。</div>
          <div>
            2、通讯费报销，必须凭本人账单发票报销，不可使用定额发票及充值发票。
          </div>
          <div>3、具体请参阅《通讯费报销管理规定》</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >通讯费费报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 7">
          <div>
            1、工作流适用范围：因公产生的车辆使用费，仅适用于安吉华宇员工。
          </div>
          <div>
            2、车辆产生的各项费用，包括燃油费、保险费、修理费、车辆装潢费、停车费、路桥通行费、充电费等。
          </div>
          <div>3、具体参阅《公务用车补贴报销制度》。</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >用车费报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 8">
          <div>1、工作流适用范围：因公按规定在额度内报销的房费及用车费用。</div>
          <div>
            2、车辆产生的各项费用，包括燃油费、保险费、修理费、车辆装潢费、停车费、路桥通行费、充电费等。
          </div>
          <div>3、房费包括房屋租赁费、住宿费等。</div>
          <div>
            4、报销人开户名和账号必须与享受房补车补的申请人员工本人一致。
          </div>
          <div>5、具体请参阅《车补房补管理规定》。</div>
          <div>
            6、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >房费车费报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 9">
          <div>
            1、工作流适用范围：各类日常福利费报销，包括但不限于误餐费、食堂用品、总监体检费、防暑降温费、不超过2000的生活用品和食堂用品采购、以及员工生日费用等。
          </div>
          <div>2、各类费用报销需符合人力资源部规定标准。</div>
          <div>3、具体请参阅《福利管理制度2022》《文化费用管理规定》。</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >日常福利报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 10">
          <div>
            1、工作流适用范围：特指因工作需要外部场所召集或受邀参加的会议，如董事会、公司年会、供应商大会、招商会、行业峰会等
          </div>
          <div>
            2、会议费用：是指根据会议类型、规模需要在外进行会场租赁、会场布置、设备租赁、文件印刷、餐食等费用。
          </div>
          <div>3、具体请参阅《会议管理制度》</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >会务费报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 11">
          <div>1、工作流适用范围：设立食堂的门店、平台、场站伙食费补贴。</div>
          <div>2、伙食费列支范围：采购的米、面、油、蔬菜等食材。</div>
          <div>3、伙食费标准请参阅《各大区宿舍食堂经营情况》表。</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >伙食费报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 12">
          <div>
            1、工作流适用范围：①各类证照办理或审检等产生的费用
            ②行政罚款：包括但不限于因证照等问题所产生的行政处罚或罚款；③其他类行政罚款。
          </div>
          <div>2、罚款类需在附件上传有关行政部门的处罚文件。</div>
          <div>3、如费用大于2000元，请附件上传向总裁办报备邮件及回复。</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >证照相关费用报销-模板</span
            >。
          </div>
        </div>
        <div class="workflow" v-if="workflow == 13">
          <div>
            1、工作流适用范围：备用金、各类押金、保证金及房租税金、工伤借款及车辆肇事借款等各类借款。 
          </div>
          <div>2、保证金或押金类需提供相应缴费凭据（招标说明书或合同）；工伤医疗借款请概述事件经过，上传事故快报表，员工签字的借条；车辆肇事借款仅限于自有车辆发生交通事故，需要抢救伤者的费用垫付申请，同时请上传交通事故分析报告。</div>
          <div>3、房租税金的核销通过零星费用报销流程完成，在报销申请时，是否冲借支选择“是”，并关联相应的借支流程及填写冲销金额。；工伤借款及车辆肇事借款报销沿用原对应费用的结案申请。</div>
          <div>
            4、工作流所需附件<span
              style="color: blue; cursor: pointer"
              @click="templateFun"
              >借支单申请-模板</span
            >。
          </div>
        </div>
      </van-collapse-item>
      <div class="jg"></div>
      <van-collapse-item title="基本信息" name="2">
        <div class="essentialInformation">
          <div>
            <div class="label">单据编号</div>
            <div class="text">{{ addForm.applyNum }}</div>
          </div>
          <div>
            <div class="label">申请人</div>
            <div class="text">{{ addForm.employeeName }}</div>
          </div>
          <div>
            <div class="label">申请人工号</div>
            <div class="text">{{ addForm.employeeCode }}</div>
          </div>
          <div>
            <div class="label">申请人岗位</div>
            <div class="text">{{ addForm.positionName }}</div>
          </div>
          <div>
            <div class="label">申请人公司</div>
            <div class="text">{{ addForm.salaryCompany }}</div>
          </div>
          <div>
            <div class="label">申请人部门</div>
            <div class="text">{{ addForm.department }}</div>
          </div>
          <div>
            <div class="label">人员成本分类</div>
            <div class="text">{{ addForm.costClassification }}</div>
          </div>
          <div>
            <div class="label">申请日期</div>
            <div class="text">{{ addForm.createTime }}</div>
          </div>
          <div>
            <div class="label">员工等级</div>
            <div class="text">{{ addForm.levelExplain }}</div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <MyTitle title="工作流信息"></MyTitle>
    <!-- <JobLiu @showPopup="showPopup"></JobLiu> -->
    <div class="gridBox">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <div class="title requiredColum">工作流名称</div>
            <van-field
              v-model="addForm.workflowName"
              disabled
              placeholder="请输入"
            />
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow != 0 && workflow != 4">
          <div class="item">
            <div class="title requiredColum">支付方式</div>
            <van-cell is-link @click="showPopup('支付方式')">{{
              addForm.paywayName || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 1">
          <div class="item">
            <div class="title">最高随行人</div>
            <van-cell is-link @click="showPopup('最高随行人')">{{
              addForm.topEntourage || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow != 0 && workflow != 4">
          <div class="item">
            <div class="title requiredColum">收款方</div>
            <van-cell is-link @click="showPopup('收款方')">{{
              addForm.payeeCombination || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 3">
          <div class="item">
            <div class="title requiredColum">是否冲借支</div>
            <van-cell is-link @click="showPopup('是否冲借支')">{{
              Number(addForm.isBorrow) ? "是" : "否" || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 3">
          <div class="item">
            <div class="title requiredColum">是否行政相关</div>
            <van-cell is-link @click="showPopup('是否行政相关')">{{
              Number(addForm.isAdministrative) ? "是" : "否" || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 3">
          <div class="item">
            <div class="title requiredColum">是否通讯费相关</div>
            <van-cell is-link @click="showPopup('是否通讯费相关')">{{
              Number(addForm.isCommunication) ? "是" : "否" || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 0 || workflow == 1 || workflow == 4">
          <div class="item">
            <div class="title requiredColum">出差类型</div>
            <van-cell is-link @click="showPopup('出差类型')">{{
              addForm.travelTypeName || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <!-- <van-grid-item v-if="workflow != 0 && workflow != 4">
          <div class="item">
            <div class="title requiredColum">费用承担部门</div>
            <van-cell is-link @click="showPopup('费用承担部门')">{{
              addForm.expenseDepartName || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item> -->
        <van-grid-item v-if="workflow != 0 && workflow != 4">
          <div class="item">
            <div class="title requiredColum">预算单位</div>
            <van-cell is-link @click="workflow != 5 && showPopup('预算单位')" :disabled="workflow == 5">
              {{ addForm.budgetUnit || "请选择" }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item
          v-if="
            workflow == 2 ||
            workflow == 3 ||
            workflow == 5 ||
            workflow == 6 ||
            workflow == 7 ||
            workflow == 9 ||
            workflow == 10 ||
            workflow == 11 ||
            workflow == 12
          "
        >
          <div class="item">
            <div class="title requiredColum">费用类型</div>
            <van-cell is-link @click="showPopup('费用类型')">{{
              addForm.costName || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 13">
          <div class="item">
            <div class="title requiredColum">借支类型</div>
            <van-cell is-link @click="showPopup('借支类型')">{{
              (jzList.find(item=>item.name == addForm.borrowType) || {}).code || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 13 && addForm.borrowType == 1">
          <div class="item">
            <div class="title requiredColum">投标公司</div>
            <van-field
              v-model="addForm.biddingCompany"
              placeholder="请输入"
              type="text"
            />
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 13 && addForm.borrowType == 2">
          <div class="item">
            <div class="title requiredColum">客户名称</div>
            <van-field
              v-model="addForm.biddingCompany"
              placeholder="请输入"
              type="text"
            />
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 13">
          <div class="item">
            <div class="title requiredColum">本次借款金额</div>
            <van-field
              v-model="addForm.applyAmount"
              placeholder="请输入"
              type="number"
            />
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 11">
          <div class="item">
            <div class="title requiredColum">是否无票</div>
            <van-cell is-link @click="showPopup('是否无票')">
              <span v-if="addForm.haveInvoice == 0">否</span>
              <span v-else-if="addForm.haveInvoice == 1">是</span>
              <span v-else>请选择</span>
            </van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 11">
          <div class="item">
            <div class="title requiredColum">开始时间</div>
            <van-cell is-link @click="showPopup('beginDate')">{{
              addForm.leaveTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 11">
          <div class="item">
            <div class="title requiredColum">结束时间</div>
            <van-cell is-link @click="showPopup('endDate')">{{
              addForm.returnTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 9">
          <div class="item">
            <div class="title requiredColum">
              开始日期
            </div>
            <van-cell is-link @click="showPopup('开始日期')">{{
              addForm.leaveTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 9">
          <div class="item">
            <div class="title requiredColum">结束日期</div>
            <van-cell is-link @click="showPopup('结束日期')">{{
              addForm.returnTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item
                v-if="
                  workflow == 9 &&
                  String(addForm.costName).indexOf('生活用品') != -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">发生季度</div>
                  <van-cell is-link @click="showPopup('发生季度', index)">{{
                    addForm.dictKey || "请选择"
                  }}</van-cell>
                  <!-- {{item.showPopup}} -->
                </div>
              </van-grid-item>
              <van-grid-item
                v-if="
                  workflow == 9 &&
                  String(addForm.costName).indexOf('防暑降温费') != -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">气温情况</div>
                  <van-cell is-link @click="showPopup('气温情况', index)">{{
                    addForm.dictKeyName || "请选择"
                  }}</van-cell>
                </div>
              </van-grid-item>
        <van-grid-item v-if="workflow == 11">
          <div class="item">
            <div class="title requiredColum">人数</div>
            <van-field
              v-model="addForm.number"
              placeholder="请输入"
              type="number"
            />
            <!-- {{item.number}} -->
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 11">
          <div class="item">
            <div class="title requiredColum">城市</div>
            <van-cell is-link @click="showPopup('city')">{{
              addForm.city || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 9">
          <div class="item">
            <div class="title requiredColum">数量</div>
            <van-field
              v-model="addForm.number"
              placeholder="请输入"
              type="number"
            />
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 9 || workflow == 11">
          <div class="item">
            <div class="title requiredColum">单价</div>
            <van-field
              v-model="addForm.price"
              placeholder="请输入"
              :disabled="workflow == 9"
              type="number"
            />
          </div>
        </van-grid-item>
        
        <van-grid-item v-if="workflow == 1 || workflow == 0">
          <div class="item">
            <div class="title requiredColum">开始日期</div>
            <van-cell is-link @click="showPopup('开始日期')">{{
              addForm.leaveTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 1 || workflow == 0">
          <div class="item">
            <div class="title requiredColum">结束日期</div>
            <van-cell is-link @click="showPopup('结束日期')">{{
              addForm.returnTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 4">
          <div class="item">
            <div class="title requiredColum">出发日期</div>
            <van-cell is-link @click="showPopup('出发日期')">{{
              addForm.leaveTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 4">
          <div class="item">
            <div class="title requiredColum">返回日期</div>
            <van-cell is-link @click="showPopup('返回日期')">{{
              addForm.returnTime || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 0 || workflow == 1">
          <div class="item">
            <div class="title requiredColum">始发地</div>
            <van-cell is-link @click="showPopup('sf')">{{
              sf || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 0 || workflow == 1">
          <div class="item">
            <div class="title">途径地(1)</div>
            <van-cell is-link @click="showPopup('tjone')">{{
              tjone || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 0 || workflow == 1">
          <div class="item">
            <div class="title">途径地(2)</div>
            <van-cell is-link @click="showPopup('tjtwo')">{{
              tjtwo || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item v-if="workflow == 0 || workflow == 1">
          <div class="item">
            <div class="title requiredColum">目的地</div>
            <van-cell is-link @click="showPopup('md')">{{
              md || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
      </van-grid>
      <div
        style="background: #fff; padding: 10px 20px"
        v-if="workflow == 0 || workflow == 1"
      >
        <div class="title">出差路径</div>
        <span>{{ addForm.itinerary || "---" }}</span>
      </div>
      <div style="background: #fff; padding: 10px 20px">
        <div class="title">申请事由及说明</div>
        <van-field
          v-model="addForm.applyReason"
          maxlength="300"
          placeholder="请输入"
        />
      </div>
    </div>
    <MyTitle title="入账子公司" v-if="workflow != 1 && workflow != 4 && workflow != 13"></MyTitle>
    <!-- <DocRelate @showPopup="showPopup"></DocRelate> -->
    <div class="gridBox" v-if="workflow != 1 && workflow != 13">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <div class="title requiredColum">入账子公司</div>
            <van-cell is-link>{{ addForm.bookingSubsidiary }}</van-cell>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <MyTitle title="关联单据" v-if="workflow == 1|| workflow == 3"></MyTitle>
    <!-- <DocRelate @showPopup="showPopup"></DocRelate> -->
    <div class="gridBox" v-if="addForm.workflowName == '出差费用报销' || workflow == 3">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <div class="title requiredColum">关联事前申请单</div>
            <van-cell is-link @click="jumpSq">{{
              addForm.advanceApplyNum || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="item">
            <div class="title">金额</div>
            <span style="color: rgb(109, 113, 132)">{{
              addForm.advanceApplyAmountStr || "—"
            }}</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <MyTitle
      title="是否超标"
      v-if="addForm.workflowName == '出差费用报销'"
    ></MyTitle>
    <div class="gridBox" v-if="addForm.workflowName == '出差费用报销'">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <div class="title">是否超标</div>
            <van-cell is-link @click="showPopup('是否超标')">{{
              addForm.excess || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="item">
            <div class="title">超标申请</div>
            <van-cell is-link @click="$router.push('/selectCb')">{{
              addForm.excessApplyNum || "请选择"
            }}</van-cell>
          </div>
        </van-grid-item>
      </van-grid>
    </div>

    <MyTitle v-if="workflow == 0" title="行程信息"></MyTitle>
    <MyTitle v-else title="费用明细"></MyTitle>
    <van-tabs v-model="active"  @click="tabClick">
      <!-- <van-tab
        v-if="workflow == 11 && !addForm.haveInvoice"
        title="发票夹"
        name="发票夹"
      ></van-tab> -->
      <van-tab
        v-if="workflow != 0 && workflow != 4 && workflow != 13"
        title="发票夹"
        name="发票夹"
      ></van-tab>
      <van-tab v-if="workflow != 4&& workflow != 13" title="明细信息" name="明细信息"></van-tab>
      <van-tab title="附件信息" name="附件信息"></van-tab>
    </van-tabs>
    <!-- <DetailInformation
      @showPopup="showPopup"
      v-show="active == 0"
    ></DetailInformation> -->
    <!-- 明细信息 -->
    <van-swipe ref="swiper" duration="500" :loop="false"  @change="swiperChange">
      <van-swipe-item v-if="workflow != 0 && workflow != 4&& workflow != 13">
        <div class="gridBox" style="background: #fff">
          <div v-for="(item, index) in addForm.detailRequestList" :key="index">
            <div class="tabContro van-hairline--bottom">
              <div class="tit">发票({{ index + 1 }})</div>
              <div class="del" @click="deleteItem(index)">删除</div>
            </div>
            <div class="essentialInformation">
              <div>
                <div class="label">票据类型</div>
                <div class="text">{{ item.invoiceTypeName }}</div>
              </div>
              <div>
                <div class="label">发票号码</div>
                <div class="text">{{ item.invoiceNumber }}</div>
              </div>
              <div>
                <div class="label">发票服务名称</div>
                <div class="text">{{ item.goodsName }}</div>
              </div>
              <div>
                <div class="label">发票代码</div>
                <div class="text">{{ item.invoiceCode }}</div>
              </div>
              <div>
                <div class="label">不含税金额</div>
                <div class="text">{{ item.noTaxAmountStr }}</div>
              </div>
              <div>
                <div class="label">税率</div>
                <div class="text">{{ item.taxRate }}</div>
              </div>
              <div>
                <div class="label">税额</div>
                <div class="text">{{ item.taxAmountStr }}</div>
              </div>
              <div>
                <div class="label">价税合计</div>
                <div class="text">{{ item.totalAmountStr }}</div>
              </div>
              <!-- <div>
                <div class="label">本次报销金额</div>
                <div class="text">123456</div>
              </div>
              <div>
                <div class="label">说明</div>
                <div class="text">213213213213</div>
              </div> -->
            </div>
          </div>
          <div class="add noCopy" onbeforecopy="return false">
            <van-button @click="jump('/selectInvoice')"
              ><svg-icon
                icon-class="add"
                style="margin-right: 4px"
              />选择发票</van-button
            >
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item  v-if="workflow != 4&& workflow != 13">
        <div>
          <div
            class="gridBox"
            v-for="(item, index) in addForm.detailRequestList"
            :key="index"
          >
            <div class="tabContro">
              <div class="tit">明细信息({{ index + 1 }})</div>
              <div class="del" @click="deleteItem(index)">删除</div>
            </div>
            <van-grid column-num="2">
              <van-grid-item v-if="workflow == 1 || workflow == 8">
                <div class="item">
                  <div class="title requiredColum">费用类型</div>
                  <van-cell is-link @click="showPopup('费用类型', index)">{{
                    item.costName || "请选择"
                  }}</van-cell>
                  <!-- {{item.costName}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">开始时间</div>
                  <van-cell is-link @click="showPopup('beginDate', index)">{{
                    item.beginDate || "请选择"
                  }}</van-cell>
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">结束时间</div>
                  <van-cell is-link @click="showPopup('endDate', index)">{{
                    item.endDate || "请选择"
                  }}</van-cell>
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2 || workflow == 3">
                <div class="item">
                  <div class="title requiredColum">发生日期</div>
                  <van-cell is-link @click="showPopup('发生日期', index)">{{
                    item.occurTime || "请选择"
                  }}</van-cell>
                  <!-- {{item.occurTime}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 6">
                <div class="item">
                  <div class="title requiredColum">费用发生(月份)</div>
                  <van-cell is-link @click="showPopup('费用发生(月份)', index)">{{
                    item.occurMonth || "请选择"
                  }}</van-cell>
                  <!-- {{item.occurMonth}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2">
                <div class="item">
                  <div class="title requiredColum">始发地</div>
                  <van-field
                    v-model="item.provenance"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.provenance}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2">
                <div class="item">
                  <div class="title requiredColum">目的地</div>
                  <van-field
                    v-model="item.destination"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.destination}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2">
                <div class="item">
                  <div class="title">外出事由</div>
                  <van-field
                    v-model="item.costDescription"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.forceUpdate}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 1">
                <div class="item">
                  <div class="title">仓位</div>
                  <van-field
                    v-model="item.classLevel"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.classLevel}} -->
                </div>
              </van-grid-item>
              <van-grid-item>
                <div class="item">
                  <div class="title requiredColum">
                    {{ workflow == 0 ? "预计金额" : "报销金额" }}
                  </div>
                  <van-field
                    v-model="item.amount"
                    @input="forceUpdate(item, 'amount')"
                    placeholder="请输入"
                  />
                  <!-- {{item.amountStr}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 0 || workflow == 1">
                <div class="item">
                  <div class="title">出行工具</div>
                  <van-cell is-link @click="showPopup('出行工具', index)">{{
                    item.travelToolName || "请选择"
                  }}</van-cell>
                  <!-- {{item.travelToolName}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item">
                  <div class="title requiredColum">招待对象</div>
                  <van-field
                    v-model="item.guests"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.guests}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item">
                  <div class="title requiredColum">招待人数</div>
                  <van-field
                    v-model="item.receptPerson"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.receptPerson}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item requiredColum">
                  <div class="title">陪同人数</div>
                  <van-field
                    v-model="item.escortsPerson"
                    @input="forceUpdate"
                    placeholder="0"
                  />
                  <!-- {{item.escortsPerson}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item">
                  <div class="title requiredColum">招待性质</div>
                  <van-cell is-link @click="showPopup('招待性质', index)">{{
                    item.receptionNatureName || "请选择"
                  }}</van-cell>
                  <!-- {{item.receptionNatureName}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 6 || workflow == 8">
                <div class="item">
                  <div class="title requiredColum">报销人</div>
                  <van-cell is-link @click="showPopup('报销人', index)">{{
                    item.reimEmployeeName || "请选择"
                  }}</van-cell>
                  <!-- {{item.reimEmployeeName}} -->
                </div>
              </van-grid-item>

              <!-- <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">会务类型</div>
                  <van-cell is-link @click="showPopup('会务类型', index)">{{
                    item.meetingTypeStr || "请选择"
                  }}</van-cell>
                </div>
              </van-grid-item> -->

              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">会议地点</div>
                  <van-field
                    v-model="item.meetingPlace"
                    @input="forceUpdate(item)"
                    placeholder="请输入"
                    type="text"
                  />
                  <!-- {{item.number}} -->
                </div>
              </van-grid-item>

              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">人数</div>
                  <van-field
                    v-model="item.number"
                    @input="forceUpdate(item, 'number')"
                    placeholder="请输入"
                    type="number"
                  />
                  <!-- {{item.number}} -->
                </div>
              </van-grid-item>
              <!-- <van-grid-item v-if="workflow == 11">
                <div class="item">
                  <div class="title requiredColum">城市</div>
                  <van-field
                    v-model="item.city"
                    @input="forceUpdate(item, 'city')"
                    placeholder="请输入"
                  />
                </div>
              </van-grid-item> -->

              <!-- <van-grid-item
                v-if="
                  workflow == 9 && String(addForm.costName).indexOf('误餐费') != -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">用餐顿数</div>
                  <van-field
                    v-model="item.diningNumber"
                    @input="forceUpdate"
                    placeholder="请输入"
                    type="number"
                    :disabled="String(addForm.costName).indexOf('误餐费') != -1"
                  />
                </div>
              </van-grid-item> -->
              <!-- <van-grid-item
                v-if="
                  workflow == 9 && String(addForm.costName).indexOf('误餐费') == -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">数量</div>
                  <van-field
                    v-model="item.number"
                    @input="forceUpdate(item, 'number')"
                    placeholder="请输入"
                    type="number"
                  />
                </div>
              </van-grid-item> -->
              <!-- <van-grid-item v-if="workflow == 9">
                <div class="item">
                  <div class="title requiredColum">单价</div>
                  <van-field
                    v-model="item.price"
                    @input="forceUpdate(item, 'price')"
                    placeholder="请输入"
                    type="number"
                    :disabled="
                      String(addForm.costName).indexOf('误餐费') != -1 ||
                      String(addForm.costName).indexOf('防暑降温费') != -1 ||
                      workflow == 11
                    "
                  />
                </div>
              </van-grid-item> -->
              <van-grid-item v-if="workflow == 7 || workflow == 8">
                <div class="item">
                  <div class="title requiredColum">额度可报销余额</div>
                  {{ item.remainQuotaStr }}
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow != 2">
                <div class="item">
                  <div class="title">费用说明</div>
                  <van-field
                    v-model="item.costDescription"
                    @input="forceUpdate"
                    placeholder="请输入"
                  />
                  <!-- {{item.costDescription}} -->
                </div>
              </van-grid-item>
            </van-grid>
          </div>
          <div
            class="add noCopy"
            v-if="workflow == 0 || workflow == 11"
            onbeforecopy="return false"
          >
            <van-button @click="add"
              ><svg-icon
                icon-class="add"
                style="margin-right: 4px"
              />添加费用明细</van-button
            >
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="gridBox">
          <div
            class="tabContro van-hairline--bottom"
            v-for="(item, index) in addForm.files"
            :key="index"
          >
            <div class="tit">
              <svg-icon icon-class="fill" style="margin-right: 4px"></svg-icon
              >{{ item.fileName }}
            </div>
            <div class="del" @click="deleteFj(index)">删除</div>
          </div>
          <div class="add noCopy" onbeforecopy="return false">
            <van-button @click="upload" :loading="uploadLoading"
              ><svg-icon
                icon-class="shangchuan"
                style="margin-right: 4px"
              />上传文件</van-button
            >
          </div>
        </div>
      </van-swipe-item>
      <template #indicator>
        <div></div>
      </template>
    </van-swipe>

    <MyTitle title="关联借支单号" v-if="workflow == 3 && addForm.isBorrow"></MyTitle>
    <!-- <DocRelate @showPopup="showPopup"></DocRelate> -->
    <div class="gridBox" v-if="workflow == 3 && addForm.isBorrow" style="margin-bottom:40px;">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <van-cell class="title requiredColum" is-link @click="jump('/selectJzd')">关联借支单号</van-cell>
            <div v-for="(item,index) in addForm.writeoffDetailEntityList" :key="index">{{item.applyNum}}</div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div v-if="workflow == 3 && addForm.isBorrow">
      <div class="gridBox" v-for="(item,index) in addForm.writeoffDetailEntityList || []" :key="index">
        <div class="tabContro van-hairline--bottom">
          <div class="tit">借支单({{ index + 1 }})</div>
          <div class="del" @click="jzdDelete(index)">删除</div>
        </div>
        <van-grid column-num="2">
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">工作流名称</div>
              <van-field
                v-model="item.workflowName"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">单据编号</div>
              <van-field
                v-model="item.applyNum"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">借支类型</div>
              <van-field
                v-model="item.borrowTypeName"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">申请人</div>
              <van-field
                v-model="item.createUser"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title">借支金额</div>
              <van-field
                v-model="item.applyAmountStr"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title">剩余未冲销金额</div>
              <van-field
                v-model="item.remainAmountStr"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">本次冲销金额</div>
              <van-field
                v-model="item.writeOffAmount"
                :disabled="type!='add'&& type!='edit' "
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title">费用说明</div>
              <van-field
                v-model="item.costDescription"
                disabled
              />
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    <div class="btnBox noCopy">
      <van-button type="info" :loading="saveLoading" @click="save(true)"
        >提交</van-button
      >
    </div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div style="height: 100%">
        <van-datetime-picker
          v-if="selectDate"
          v-model="currentDate"
          @confirm="onConfirm"
          @cancel="onCancel"
          :type="dateType"
          :title="showTitle"
        />

        <van-picker
          v-if="!selectDate"
          :title="showTitle"
          show-toolbar
          :value-key="showValue"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import DetailInformation from "./components/detailInformation.vue";
import DocRelate from "./components/docRelate.vue";
import JobLiu from "./components/jobLiu.vue";
import InvoiceClip from "./components/InvoiceClip.vue";
import Attachment from "./components/attachment.vue";
import Cookies from "js-cookie";
import saveObj from "./save.js";
import { Dialog } from 'vant';

export default {
  components: {
    JobLiu, //工作流
    DocRelate, //关联单据
    DetailInformation, //明细信息
    InvoiceClip, //发票夹
    Attachment, //附件信息
  },
  mounted() {
    let that = this;
    this.$bus.$on("handleBack", () => {
      if (this.$route.meta.back && this.$route.query.type == "edit") {
        this.getData();
      }
    });
    this.$bus.$on("selectCity", (type, city) => {
      if(this.workflow==11){
        if (type == "city") this.addForm.city = city;
        this.$api
        .post("/payment/center/hoau/invCostMapping/mealStandard", {
          reqData: {
            city: this.addForm.city,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.addForm.price = res.repData;
            this.$forceUpdate();
          }
        });
      }else{
        if (type == "sf") this.sf = city;
        if (type == "tjone") this.tjone = city;
        if (type == "tjtwo") this.tjtwo = city;
        if (type == "md") this.md = city;
        this.addForm.itinerary = `${this.sf}-${this.tjone}-${this.tjtwo}-${this.md}`;
      }
    });
    this.$bus.$on("searchSelect", (row, type) => {
      // console.log(row, type, this.addIndex);
      if (type == "department") {
        this.addForm.expenseDepartName = row.departmentName;
        this.addForm.expenseDepart = row.departmentName;
        this.addForm.expenseDepartCode = row.departmentCode;
      }
      if (type == "budgetUnit") {
        this.addForm.budgetUnit = row.budgetUnit;
        this.addForm.unitCode = row.unitCode;
      }
      if (type == "cost") {
        console.log(row, "rowrow", this.addIndex);
        if (
          this.workflow == 2 ||
          this.workflow == 3 ||
          this.workflow == 5 ||
          this.workflow == 6 ||
          this.workflow == 7 ||
          this.workflow == 9 ||
          this.workflow == 10 ||
          this.workflow == 11 ||
          this.workflow == 12
        ) {
          this.addForm.costName = row.costName;
          this.addForm.costType = row.costCode;
          this.setPrice()
        } else {
          this.addForm.detailRequestList[this.addIndex].costName = row.costName;
          this.addForm.detailRequestList[this.addIndex].costType = row.costCode;
        }
        if (this.addForm.workflow == 9) {
          this.addForm.detailRequestList.forEach((item) => {
            if (this.addForm.costName.indexOf("误餐费") != -1) {
              delete item.dictKey; //气温情况
              delete item.number; //数量
              delete item.dictKey; //发生季度
            }
            if (this.addForm.costName.indexOf("生活用品") != -1) {
              delete item.dictKey; //气温情况
              delete item.diningNumber; //顿数
              delete item.leaveTime; //开始时间
              delete item.backTime; //结束时间
            }
            if (this.addForm.costName.indexOf("防暑降温费") != -1) {
              delete item.dictKey; //发生季度
              delete item.diningNumber; //顿数
              delete item.leaveTime; //开始时间
              delete item.backTime; //结束时间
            }
          });
        }
        this.$forceUpdate();
        if (this.workflow == 8) {
          this.setEd();
        }
      }
      if (type == "topEntourage") {
        if (this.showTitle == "最高随行人") {
          this.addForm.topEntourage = row.employeeName;
          this.addForm.topEntourageId = row.employeeId;
        }
        if (this.showTitle == "报销人") {
          this.addForm.detailRequestList[this.addIndex].reimEmployeeName =
            row.employeeName;
          this.addForm.detailRequestList[this.addIndex].reimEmployeeCode =
            row.employeeCode;
          if (this.workflow == 8) {
            this.setEd();
          }
        }
      }
      this.$forceUpdate();
    });
    this.$bus.$on("selectJzd", function (arr) {
       arr.forEach(item=>{
        if(!that.addForm.writeoffDetailEntityList.find(i=>i.applyNum == item.applyNum)){
          that.addForm.writeoffDetailEntityList.push({
            ...item,
            writeOffAmount:"",
            writeOffAmountStr:"",
          })
        }
      })
      that.addForm.writeoffDetailEntityList = JSON.parse(JSON.stringify(that.addForm.writeoffDetailEntityList))
      that.$nextTick(()=>{
        that.$forceUpdate()
      })
    })
    this.$bus.$on("selectClip", function (arr) {
      that.clipAdd(arr);
      that.active = "发票夹";
      that.$refs.swiper.swipeTo(0)
      that.$forceUpdate();
      console.log("fpfpfpfpfpfpfpfp", that.workflow);
      if (that.workflow == 7 || that.workflow == 8) {
        that.setEd();
      }
    });
    this.$bus.$on("relevanceFun", (row) => {
      this.addForm.advanceApplyId = row.id;
      this.addForm.advanceApplyNum = row.applyNum;
      this.addForm.advanceApplyAmountStr = row.payAmountStr;
      this.addForm.advanceApplyAmount = row.payAmount;
      this.$forceUpdate();
    });
    this.$bus.$on("selectCb", (row) => {
      this.addForm.excessApplyId = row.id;
      this.addForm.excessApplyNum = row.applyNum;
      this.$forceUpdate();
    });
  },
  created() {
    this.setDefault();
    if (this.type == "add") {
      if (this.$route.query.clipList) {
        let arr = JSON.parse(this.$route.query.clipList);
        this.clipAdd(arr);
      }
    }
  },
  computed: {
    workflow() {
      return this.addForm.workflow;
    },
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    },
    dataLength() {
      return this.addForm.detailRequestList.length;
    },
  },
  watch: {
    active(newVal){
      if(this.oneActive <= 3 && this.type == "edit"){
        this.tabClick(newVal)
        this.oneActive += 1
      }
    },
    workflow(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setDefault();
      }
    },
    type(newVal) {},
    id() {
      // this.setDefault();
    },
    scrollTop(newOld) {
      let main = document.querySelector("#main");
      main.scrollTop = newOld;
    },
    dataLength:{
      handler:function(newval) {
      console.log(newval, "发票数量变化");
      // 发票数量
      if (this.type != "edit" && this.type != "add") return;
      this.addForm.invoiceNumber = newval;
      let arr = [];
      if (this.addForm.detailRequestList) {
        arr = this.addForm.detailRequestList;
      }
      // 入账子公司
      arr.forEach((item,index) => {
        if (index == 0) {
          if (item.buyerName) {
            this.addForm.bookingSubsidiary = item.buyerName;
          }
        }else{
          if (item.buyerName && !this.addForm.bookingSubsidiary) {
            this.addForm.bookingSubsidiary = item.buyerName;
          }
        }
      });
      if (!newval) {
        console.log("清空入账子公司");
        this.addForm.bookingSubsidiary = "";
      }
    },
    deep:true
    }
  },
  beforeRouteLeave(to, form, next) {
    console.log("离开");
    let main = document.querySelector("#main");
    this.oldScrollTop = main.scrollTop;
    this.scrollTop = 0;
    next();
  },
  beforeRouteEnter(to, form, next) {
    console.log("进入");
    next((vm) => {
      vm.scrollTop = vm.oldScrollTop;
      if (vm.$route.params.fristEnter && vm.type !== "add") {
        vm.getData();
        vm.oneActive = 1
      }
      console.log(vm.$route.params.fristEnter);
      if (vm.$route.params.fristEnter && vm.type === "add") {
        console.log("fristEnter");
        vm.addForm = {
          detailRequestList: [],
          writeoffDetailEntityList:[],
          files: [],
          expenseDepartName: "",
          workflow: "",
          isExcess: 0,
          excess: "否",
        };
        vm.sf = "";
        vm.tjone = "";
        vm.tjtwo = "";
        vm.md = "";
        vm.defaultCost = {};
        vm.isgetData = 0;
        vm.travelTypeCost = "";
        vm.currentDate = "";
        vm.setDefault();
        vm.$forceUpdate();
      }
      if(vm.workflow == 0 ){
        if(vm.active == "明细信息"){vm.$refs.swiper.swipeTo(0)}
        if(vm.active == "附件信息"){vm.$refs.swiper.swipeTo(1)}
      }
      if(vm.workflow == 4 ){
        if(vm.active == "附件信息"){vm.$refs.swiper.swipeTo(0)}
      }
      if(vm.workflow != 0 && vm.workflow != 4){
        if(vm.active == "发票夹"){vm.$refs.swiper.swipeTo(0)}
        if(vm.active == "明细信息"){vm.$refs.swiper.swipeTo(1)}
        if(vm.active == "附件信息"){vm.$refs.swiper.swipeTo(2)}
      }
    })
  },
  data() {
    return {
      jzList:[],
      oneActive:1,
      bookingSubsidiaryFlag: false,
      saveLoading: false,
      meetingList: [], //会务类型
      uploadLoading: false,
      dateType: "date",
      dateType2: "",
      quarterArr: [],
      temperatureArr: [],
      zdArr: [],
      fjList: [],
      oldScrollTop: 0,
      scrollTop: 0,
      sf: "",
      tjone: "",
      tjtwo: "",
      md: "",
      defaultCost: {},
      isgetData: 0,
      travelTypeCost: "",
      currentDate: "",
      addForm: {
        detailRequestList: [],
        writeoffDetailEntityList:[],
        files: [],
        expenseDepartName: "",
        workflow: "",
        isExcess: 0,
        excess: "否",
      },
      addIndex: "",
      activeNames: ["2"],
      value: "",
      selectDate: false,
      show: false,
      showTitle: "", //弹框title
      showValue: "", //选项value值
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      active: "发票夹",
      backLabel: "",
      departmentList: [], //费用承担部门
      jobNames: [], //工作流名称
      payTypeList: [], //支付方式
      currentList: [], //币种
      travelType: [], //出差类型
      backList: [], //收款方信息
      backId: "",
      costList: [], //费用类型
      toolList: [], //出行工具
      paperList: [], //票据类型
      taxRateList: [],
      info: {},
      defaultAmount: "",
      swiperIndex:0,
    };
  },
  methods: {
    jumpSq(){
      let query = {
        workflow:this.addForm.workflow,
      }
      if(this.addForm.workflow == 3){
        query.employeeCode = this.addForm.employeeCode
        query.costType = this.addForm.costType
        if(!this.addForm.costType){
          this.$toast("请选择费用类型");
          return
        }
      }
      this.$router.push({
        path:"/relevance",
        query
      })
    },
    jzdDelete(ind){
      this.addForm.writeoffDetailEntityList = this.addForm.writeoffDetailEntityList.filter((item,index)=>index!==ind)
      this.$forceUpdate()
    },
    tabClick(name){
      if(this.workflow == 0 ){
        if(name == "明细信息"){this.$refs.swiper.swipeTo(0)}
        if(name == "附件信息"){this.$refs.swiper.swipeTo(1)}
      }
      if(this.workflow == 4 ){
        if(name == "附件信息"){this.$refs.swiper.swipeTo(0)}
      }
      if(this.workflow != 0 && this.workflow != 4){
        if(name == "发票夹"){this.$refs.swiper.swipeTo(0)}
        if(name == "明细信息"){this.$refs.swiper.swipeTo(1)}
        if(name == "附件信息"){this.$refs.swiper.swipeTo(2)}
      }
    },
    swiperChange(index){
      this.swiperIndex = index
      if(this.workflow == 0 ){
        if(index == 0){this.active = "明细信息"}
        if(index == 1){this.active = "附件信息"}
      }
      if(this.workflow == 4 ){
        if(index == 0){this.active = "附件信息"}
      }
      if(this.workflow != 0 && this.workflow != 4){
        if(index == 0){this.active = "发票夹"}
        if(index == 1){this.active = "明细信息"}
        if(index == 2){this.active = "附件信息"}
      }
    },
    // fz是否赋值
    setBt(fz) {
      console.log("setBtsetBtsetBtsetBtsetBtsetBt");
      if (
        this.addForm.leaveTime &&
        this.addForm.returnTime &&
        (this.travelTypeCost === 0 ||
          this.travelTypeCost === "0" ||
          this.travelTypeCost)
      ) {
        if (this.type == "add" || this.type == "edit") {
          this.$api
            .post("/payment/center/expense/cost/getHoauCostList", {
              reqData: {
                companyId: Cookies.get("payapp_companyId"),
                travelType: this.travelTypeCost,
                workflow: this.addForm.workflow,
              },
              token: Cookies.get("payapp_token"),
            })
            .then(async (res) => {
              if (res.repCode == "0000") {
                let priRes = await this.$api.post(
                  "/payment/center/hoau/invCostMapping/travelAllowance",
                  {
                    reqData: {
                      leaveTime: new Date(this.addForm.leaveTime)
                        .toLocaleDateString()
                        .split("/")
                        .join("-"),
                      returnTime: new Date(this.addForm.returnTime)
                        .toLocaleDateString()
                        .split("/")
                        .join("-"),
                    },
                    token: Cookies.get("payapp_token"),
                  }
                );
                if (priRes.repCode == "0000") {
                  this.defaultAmount = priRes.repData;
                }
                let obj = res.repData.list.find(
                  (item) => item.costName.indexOf("补贴") != -1
                );
                let btRow = this.addForm.detailRequestList.find(
                  (item) => String(item.costName).indexOf("补贴") != -1
                );
                if (btRow) {
                  if (this.type == "add") {
                    btRow.amount = priRes.repData;
                    btRow.costName = obj.costName;
                    btRow.costType = obj.costCode;
                  }
                  if (this.type == "edit") {
                    console.log(this.defaultAmount);
                    if (
                      this.defaultAmount !== 0 &&
                      this.defaultAmount !== "0" &&
                      this.defaultAmount &&
                      fz !== "detail"
                    ) {
                      btRow.amount = priRes.repData;
                      btRow.costName = obj.costName;
                      btRow.costType = obj.costCode;
                      console.log(btRow);
                    }
                  }
                } else {
                  obj &&
                    this.addForm.detailRequestList.push({
                      costName: obj.costName,
                      costType: obj.costCode,
                      amount: priRes.repData,
                      add: true,
                      delIndex: new Date().getTime(),
                    });
                }
                this.$forceUpdate();
              }
            });
        }
      }
    },
    setEd() {
      let list = this.addForm.detailRequestList.map((item) => {
        if (this.workflow == 7) {
          return {
            ln: String(item.delIndex),
            employeeCode: this.addForm.employeeCode,
            costType: this.addForm.costType,
            amount: item.amount,
          };
        }
        if (this.workflow == 8) {
          return {
            ln: String(item.delIndex),
            employeeCode: item.reimEmployeeCode,
            costType: item.costType,
            amount: item.amount,
          };
        }
      });
      return this.$api
        .post("/payment/center/hoau/quota/selectRemainQuota", {
          reqData: {
            list,
          },
          token: Cookies.get("payapp_token"),
        })
        .then((res) => {
          if (res.repCode === "0000") {
            res.repData.map((item) => {
              this.addForm.detailRequestList.forEach((i) => {
                if (i.delIndex == item.ln) {
                  i.remainQuota = item.remainQuota;
                  i.remainQuotaStr = item.remainQuota.toLocaleString();
                }
              });
              this.addForm.detailRequestList = JSON.parse(
                JSON.stringify(this.addForm.detailRequestList)
              );
            });
          }
        });
    },
    clipAdd(arr = []) {
      let that = this;
      let obj = {};
      if (that.workflow == 0) {
        obj = {
          beginTime: new Date().toLocaleDateString().split("/").join("-"), //开始日期
          endTime: new Date().toLocaleDateString().split("/").join("-"), //结束日期
        };
      }
      if (that.workflow == 3 || that.workflow == 2) {
        obj = {
          occurTime: new Date().toLocaleDateString().split("/").join("-"), //发生日期
        };
      }
      that.currentDate = new Date();
      arr.map(async (item) => {
        let costObj = {};
        let res = await that.setDefaultCost({
          travelType: that.addForm.travelType,
          serviceName: item.goodsName,
          invoiceType: item.invoiceType,
          taxRate: item.taxRate,
        });
        if (res.repCode == "0000") {
          costObj = res.repData || {};
        }
        that.addForm.detailRequestList.push({
          delIndex: new Date().getTime(),
          ...item,
          ...costObj,
          clipCheck: true,
          // isEdit: 1, //发票是否修改
          department: that.info.department, //费用承担部门
          departmentName: that.info.department, //费用承担部门
          departmentCode: that.info.departmentCode, //费用承担部门编码
          ...obj,
          amount: item.totalAmount,
          taxAmount: item.taxAmount || 0,
          travelToolName: "", //出行工具
          // invoiceTypeName: "", //票据类型
          provenance: "", //始发地
          destination: "", //目的地
          costDescription: "", //费用说明
        });
        this.setRz()
        this.$forceUpdate();
      });
      that.active = "发票夹";
      that.$refs.swiper.swipeTo(0)
    },
    setRz(){
      this.addForm.invoiceNumber = this.addForm.detailRequestList.length;
      let newArr = [];
      if (this.addForm.detailRequestList) {
        newArr = this.addForm.detailRequestList;
      }
      // 入账子公司
      newArr.forEach((item,index) => {
        if (index == 0) {
          if (item.buyerName) {
            this.addForm.bookingSubsidiary = item.buyerName;
          }
        }else{
          if (item.buyerName && !this.addForm.bookingSubsidiary) {
            this.addForm.bookingSubsidiary = item.buyerName;
          }
        }
      });
      if (!this.addForm.detailRequestList.length) {
        console.log("清空入账子公司");
        this.addForm.bookingSubsidiary = "";
      }
    },
    templateFun() {
      let obj = this.fjList.find((item) => item.name == this.addForm.workflow);
      if(obj){
        this.$api.look({
          filePath: obj.code,
          fileName: `${this.addForm.workflowName}-模板`,
        });
      }
    },
    handleCity() {
      this.addForm.itinerary =
        this.sf + "-" + this.tjone + "-" + this.tjtwo + "-" + this.md;
    },
    setDefaultCost({ travelType, invoiceType, serviceName, taxRate }) {
      return this.$api.post(
        "/payment/center/hoau/invCostMapping/selectMapping",
        {
          reqData: {
            travelType,
            invoiceType,
            serviceName,
            taxRate,
          },
        }
      );
    },
    setPrice(){
      if (this.workflow == 9) {
        let params ={
          costCode: this.addForm.costType,
        }
        if(this.addForm.costName.indexOf('防暑降温费')!=-1){
          params.dictKey = this.addForm.dictKey
          if(!this.addForm.dictKey)return
        }
        this.$api
        .post("/payment/center/hoau/invCostMapping/welfareStandard", {
          reqData: params,
        })
        .then((res) => {
          if(res.repCode === "0000"){
            this.addForm.price = res.repData.standard || "0";
            this.$nextTick(()=>{
              this.$forceUpdate()
            })
          } 
        });
      }
    },
    forceUpdate(row, type) {
      if (
        String(this.addForm.costName).indexOf("防暑降温费") != -1 &&
        type == "number"
      ) {
        row.amount = row.number * row.price;
      }
      if (this.workflow == 11) {
        if (type == "number" || type == "price") {
          row.amount = Number(row.number || 0) * Number(row.price || 0);
        }
        if (type == "city") {
          this.$api
            .post("/payment/center/hoau/invCostMapping/mealStandard", {
              reqData: {
                city: this.addForm.city,
              },
            })
            .then((res) => {
              if (res.repCode == "0000") {
                this.addForm.price = res.repData;
                // row.amount =
                //   Number(row.number || 0) * Number(row.price || 0);
                this.$forceUpdate();
              }
            });
        }
      }
      if (type == "amount") {
        if (this.workflow == 7 || this.workflow == 8) {
          this.setEd();
        }
        if (this.workflow == 1) {
          let obj = this.addForm.detailRequestList.find(
            (item) => String(item.costName).indexOf("补贴") != -1
          );
          if (
            this.defaultAmount !== 0 &&
            this.defaultAmount !== "0" &&
            this.defaultAmount
          ) {
            if (obj && obj.amount > this.defaultAmount) {
              obj.amount = this.defaultAmount;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    setDefault() {
      if (this.type == "add") {
        this.addForm.workflowName = this.$route.query.workflowName;
        this.addForm.workflow = this.$route.query.workflow;
        this.addForm.createTime = new Date()
          .toLocaleDateString()
          .split("/")
          .join("-");
        this.getList();
        this.getInfo();
        // this.addForm.paywayName = "网银标准支付";
        // this.addForm.payway = "0";
        this.addForm.currency = "CNY";
        this.addForm.isCommunicationName = "否";
        this.addForm.isCommunication = 0;
        this.addForm.isAdministrativeName = "否";
        this.addForm.isAdministrative = 0;
        this.addForm.isBorrow = 0;
        this.addForm.writeoffDetailEntityList=[]
        if (this.addForm.workflow == 11) {
          this.addForm.haveInvoice = 0;
        }
        if (
          this.addForm.workflow == 2 ||
          this.addForm.workflow == 3 ||
          this.addForm.workflow == 5 ||
          this.addForm.workflow == 6 ||
          this.addForm.workflow == 7
        ) {
          this.getCostList();
        }
        if (this.addForm.workflow == 1) {
          this.addForm.isExcess == 0;
          this.addForm.excess = "否";
        }
        if (
          this.addForm.workflow == 0 ||
          this.addForm.workflow == 1 ||
          this.addForm.workflow == 4
        ) {
          (this.addForm.leaveTime = new Date()
            .toLocaleDateString()
            .split("/")
            .join("-")), //出发日期
            (this.addForm.returnTime = new Date()
              .toLocaleDateString()
              .split("/")
              .join("-")), //返回日期
            (this.currentDate = new Date());
        }
        this.$forceUpdate();
      } else {
        this.getList();
      }
      if (this.type == "edit") {
        this.getData();
      }
      if (this.workflow == 4) {
        this.active = "附件信息";
        this.$forceUpdate();
      } else {
        this.active = "发票夹";
        this.$forceUpdate();
      }
    },
    onConfirm(value, index) {
      if (!value) {
        this.show = false;
        return;
      }
      if (this.workflow == 9 && this.showTitle == "开始时间") {
        this.addForm.detailRequestList[this.addIndex].leaveTime = value;
      }
      if (this.workflow == 9 && this.showTitle == "结束时间") {
        this.addForm.detailRequestList[this.addIndex].backTime = value;
      }
      if (
        this.workflow == 9 &&
        (this.showTitle == "开始时间" || this.showTitle == "结束时间")
      ) {
        let leaveTime = this.addForm.detailRequestList[this.addIndex].leaveTime;
        let backTime = this.addForm.detailRequestList[this.addIndex].backTime;
      }
      if (this.showTitle == "招待性质") {
        this.addForm.detailRequestList[this.addIndex].receptionNature =
          value.code;
        this.addForm.detailRequestList[this.addIndex].receptionNatureName =
          value.name;
      }
      if (this.showTitle == "支付方式") {
        this.addForm.paywayName = value.code;
        this.addForm.payway = value.name;
      }
      if (this.showTitle == "币种") {
        this.addForm.currency = value.name;
        this.addForm.currencyName = value.code;
      }
      if (this.showTitle == "收款方") {
        this.addForm.payeeCombination = value.label;
        this.addForm.bankAccount = value.bankAccount;
        this.addForm.bankName = value.bankName;
        this.addForm.branchName = value.branchName;
        this.addForm.regionCode = value.regionCode;
        this.addForm.accountNum = value.accountNum;
        this.addForm.accountNature = value.nature;
        this.addForm.payeeProvince = value.province;
        this.addForm.payeeCity = value.city;
      }
      if (this.showTitle == "出差类型") {
        this.addForm.travelType = value.name;
        this.addForm.travelTypeName = value.code;
        this.isgetData = 1;
        this.travelTypeCost = value.name;
        if (this.workflow == 1) {
          this.setBt();
          this.addForm.detailRequestList.map((item) => {
            this.setDefaultCost({
              travelType: value.name,
              invoiceType: item.invoiceType,
              serviceName: item.goodsName,
              taxRate: item.taxRate,
            }).then((res) => {
              if (res.repCode == "0000") {
                if (res.repData) {
                  item.costName = res.repData.costName;
                  item.costType = res.repData.costType;
                }
              }
            });
          });
        }
      }
      if(this.showTitle == "借支类型"){
        this.addForm.borrowType = value.name;
      }
      if (this.showTitle == "是否分摊") {
        this.addForm.isAbsorption = value.name;
        this.addForm.isAbsorptionName = value.code;
      }
      if (this.showTitle == "是否行政相关") {
        this.addForm.isAdministrative = value.name;
        this.addForm.isAdministrativeName = value.code;
      }
      if (this.showTitle == "是否冲借支") {
        this.addForm.isBorrow = value.name;
      }
      if (this.showTitle == "是否通讯费相关") {
        this.addForm.isCommunication = value.name;
        this.addForm.isCommunicationName = value.code;
      }
      if (this.showTitle == "费用承担部门") {
        if (this.workflow == 1 || this.workflow == 2 || this.workflow == 3) {
          this.addForm.expenseDepartName = value.departmentName;
          this.addForm.expenseDepartCode = value.departmentCode;
        } else {
          this.addForm.detailRequestList[this.addIndex].departmentName =
            value.departmentName;
          this.addForm.detailRequestList[this.addIndex].department =
            value.departmentName;
          this.addForm.detailRequestList[this.addIndex].departmentCode =
            value.departmentCode;
        }
      }
      if (this.showTitle == "费用类型") {
        if (this.workflow == 2 || this.workflow == 3) {
          this.addForm.costName = value.costName;
          this.addForm.costType = value.costCode;
        } else {
          this.addForm.detailRequestList[this.addIndex].costName =
            value.costName;
          this.addForm.detailRequestList[this.addIndex].costType =
            value.costCode;
        }
      }
      if (this.showTitle == "出行工具") {
        this.addForm.detailRequestList[this.addIndex].travelToolName =
          value.code;
        this.addForm.detailRequestList[this.addIndex].travelTool = value.name;
      }
      if (
        (this.workflow == 11 || this.workflow == 10) &&
        this.showTitle == "开始时间"
      ) {
        if(this.workflow == 11){
          this.addForm.leaveTime = new Date(this.currentDate).toLocaleDateString()
          .split("/")
          .join("-");
        }else{
          this.addForm.detailRequestList[this.addIndex].beginDate = new Date(
            this.currentDate
          )
            .toLocaleDateString()
            .split("/")
            .join("-");
        }
        this.currentDate = "";
      }
      if (
        (this.workflow == 11 || this.workflow == 10) &&
        this.showTitle == "结束时间"
      ) {
        if(this.workflow == 11){
          this.addForm.returnTime = new Date(
          this.currentDate
        )
          .toLocaleDateString()
          .split("/")
          .join("-");
        }else{
          this.addForm.detailRequestList[this.addIndex].endDate = new Date(
          this.currentDate
        )
          .toLocaleDateString()
          .split("/")
          .join("-");
        }
        this.currentDate = "";
      }
      if (this.showTitle == "开始日期") {
        if (this.workflow == 9) {
          this.addForm.leaveTime = new Date(
            this.currentDate
          )
            .toLocaleDateString()
            .split("/")
            .join("-");
          this.dateType2 = "";
        } else {
          this.addForm.leaveTime = new Date(this.currentDate)
            .toLocaleDateString()
            .split("/")
            .join("-");
          if (this.addForm.workflow == 1) {
            this.setBt();
          }
        }
        this.currentDate = "";
      }
      if (this.showTitle == "结束日期") {
        if (this.workflow == 9) {
          this.addForm.returnTime = new Date(
            this.currentDate
          )
            .toLocaleDateString()
            .split("/")
            .join("-");
          this.dateType2 = "";
        } else {
          this.addForm.returnTime = new Date(this.currentDate)
            .toLocaleDateString()
            .split("/")
            .join("-");
          if (this.addForm.workflow == 1) {
            this.setBt();
          }
        }
        this.currentDate = "";
      }
      if (this.showTitle == "发生日期") {
        if(this.addForm.workflow == 9){
          this.addForm.beginDate = new Date(
              this.currentDate
            )
              .toLocaleDateString()
              .split("/")
              .join("-");
        }else{
          this.addForm.detailRequestList[this.addIndex].occurTime = new Date(
            this.currentDate
          )
            .toLocaleDateString()
            .split("/")
            .join("-");
        }
        this.currentDate = "";
      }
      if (this.showTitle == "出发日期") {
        this.addForm.leaveTime = new Date(this.currentDate)
          .toLocaleDateString()
          .split("/")
          .join("-");
        this.currentDate = "";
      }
      if (this.showTitle == "返回日期") {
        this.addForm.returnTime = new Date(this.currentDate)
          .toLocaleDateString()
          .split("/")
          .join("-");
        this.currentDate = "";
      }
      if (this.showTitle == "票据类型") {
        this.addForm.detailRequestList[this.addIndex].invoiceType = value.name;
        this.addForm.detailRequestList[this.addIndex].invoiceTypeName =
          value.code;
      }
      if (this.showTitle == "费用发生(月份)") {
        let arr = new Date(this.currentDate).toLocaleDateString().split("/");
        if (arr[1].length == 1) {
          arr[1] = "0" + arr[1];
        }
        let str = arr[0] + "-" + arr[1];
        this.addForm.detailRequestList[this.addIndex].occurMonth = str;
        this.currentDate = "";
      }
      if (this.showTitle == "是否超标") {
        this.addForm.isExcess = value.name;
        this.addForm.excess = value.code;
        if (this.addForm.isExcess == 0) {
          this.addForm.excessApplyId = "";
          this.addForm.excessApplyNum = "";
        }
      }
      if (this.showTitle == "发生季度") {
        this.addForm.dictKey = value.code;
      }
      if (this.showTitle == "气温情况") {
        this.addForm.dictKey = value.name;
        this.addForm.dictKeyName = value.code;
        this.$api
          .post("/payment/center/hoau/invCostMapping/welfareStandard", {
            reqData: {
              dictKey: value.name,
              costCode: this.addForm.costType,
            },
          })
          .then((res) => {
            if(res.repCode === "0000"){
              this.addForm.price = res.repData.standard || "0";
              this.$nextTick(()=>{
                this.$forceUpdate()
              })
            }
          });
      }
      if (this.showTitle == "是否无票") {
        this.addForm.haveInvoice = value.code;
      }
      if (this.showTitle == "会务类型") {
        this.addForm.detailRequestList[this.addIndex].meetingType = value.name;
        this.addForm.detailRequestList[this.addIndex].meetingTypeStr =
          value.code;
      }
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.$nextTick(()=>{
        this.$forceUpdate()
      })
      this.show = false;
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      // Toast("取消");
      this.show = false;
    },
    showPopup(val, delIndex) {
      this.selectDate = false;
      let isShow = true; //判断要不要弹出框
      if (val == "sf" || val == "tjone" || val == "tjtwo" || val == "md" ||val == "city") {
        isShow = false;
        this.$router.push({
          path: "/selectCity",
          query: {
            type: val,
          },
        });
      }
      if(val == "借支类型"){
        this.showValue = "code"
        this.columns = this.jzList
      }
      if (val == "会务类型") {
        this.addIndex = delIndex;
        this.showValue = "code";
        this.columns = this.meetingList;
      }
      if (val == "支付方式") {
        this.showValue = "code";
        this.columns = this.payTypeList;
      }
      if (val == "币种") {
        this.showValue = "code";
        this.columns = this.currentList;
      }
      if (val == "收款方") {
        this.showValue = "label";
        this.columns = this.backList;
      }
      if (val == "出差类型") {
        this.showValue = "code";
        this.columns = this.travelType;
      }
      if (val == "是否无票") {
        this.showValue = "name";
        this.columns = [
          {
            name: "是",
            code: 1,
          },
          {
            name: "否",
            code: 0,
          },
        ];
      }
      if (val == "最高随行人" || val == "报销人") {
        this.addIndex = delIndex;
        isShow = false;
        this.$router.push({
          path: "/search",
          query: {
            type: "topEntourage",
          },
        });
      }
      if (val == "费用承担部门") {
        if (delIndex) this.addIndex = delIndex;
        // this.showValue = "departmentName";
        // this.columns = this.departmentList;

        isShow = false;
        this.$router.push({
          path: "/search",
          query: {
            type: "department",
          },
        });
      }
      if (val == "预算单位") {
        isShow = false;
        this.$router.push({
          path: "/search",
          query: {
            type: "budgetUnit",
          },
        });
      }

      if (val == "费用类型") {
        this.addIndex = delIndex;
        // this.showValue = "costName";
        // this.columns = this.costList;
        if (this.workflow == 2) {
          return;
        }
        isShow = false;
        if (this.workflow != 1 || this.type == "edit") {
          this.isgetData = 1;
        }
        this.$router.push({
          path: "/search",
          query: {
            type: "cost",
            isgetData: this.isgetData,
            travelTypeCost: this.travelTypeCost,
            workflow: this.workflow,
          },
        });
      }
      if (val == "出行工具") {
        this.addIndex = delIndex;
        this.showValue = "code";
        this.columns = this.toolList;
      }
      if (val == "票据类型") {
        this.addIndex = delIndex;
        this.showValue = "code";
        this.columns = this.paperList;
      }
      if (val == "beginDate" || val == "endDate") {
        if (val == "beginDate") {
          if (this.addForm.beginDate) {
            this.currentDate =
              this.addForm.beginDate;
          } else {
            this.currentDate = new Date();
          }
        }
        if (val == "endDate") {
          if (this.addForm.endDate) {
            this.currentDate = this.addForm.endDate;
          } else {
            this.currentDate = new Date();
          }
        }
        this.dateType = "date";
        this.addIndex = delIndex;
        this.selectDate = true;
      }
      if (val == "开始时间" || val == "结束时间") {
        if (val == "开始时间") {
          if (this.addForm.detailRequestList[delIndex].leaveTime) {
            this.currentDate =
              this.addForm.detailRequestList[delIndex].leaveTime;
          } else {
            this.currentDate = "00:00";
          }
        }
        if (val == "结束时间") {
          if (this.addForm.detailRequestList[delIndex].backTime) {
            this.currentDate =
              this.addForm.detailRequestList[delIndex].backTime;
          } else {
            this.currentDate = "00:00";
          }
        }
        this.dateType = "time";
        this.addIndex = delIndex;
        this.selectDate = true;
      }
      if (val == "开始日期" || val == "结束日期") {
        this.addIndex = delIndex;
        if (val == "开始日期") {
          if (this.workflow == 9) {
            if(String(this.addForm.costName).indexOf("误餐费") != -1){
              if (this.addForm.leaveTime) {
                this.currentDate = new Date(
                  this.addForm.leaveTime
                );
              } else {
                this.currentDate = new Date();
              }
            }else{
              if (this.addForm.leaveTime) {
                this.currentDate = new Date(
                  this.addForm.leaveTime
                );
              } else {
                this.currentDate = new Date();
              }
            }
          } else {
            if (this.addForm.leaveTime) {
              this.currentDate = new Date(this.addForm.leaveTime);
            } else {
              this.currentDate = new Date();
            }
          }
        }
        if (val == "结束日期") {
          if (this.workflow == 9) {
            if (this.addForm.returnTime) {
              this.currentDate = new Date(
                this.addForm.returnTime
              );
            } else {
              this.currentDate = new Date();
            }
          } else {
            if (this.addForm.returnTime) {
              this.currentDate = new Date(this.addForm.returnTime);
            } else {
              this.currentDate = new Date();
            }
          }
        }
        this.dateType = "date";
        this.addIndex = delIndex;
        this.selectDate = true;
      }
      if (val == "发生日期") {
        if(this.addForm.workflow == 9){
          if (this.addForm.beginDate) {
            this.currentDate = new Date(
              this.addForm.beginDate
            );
          } else {
            this.currentDate = new Date();
          }
        }else{
          if (this.addForm.detailRequestList[delIndex].occurTime) {
            this.currentDate = new Date(
              this.addForm.detailRequestList[delIndex].occurTime
            );
          } else {
            this.currentDate = new Date();
          }
        }
        this.dateType = "date";
        this.addIndex = delIndex;
        this.selectDate = true;
      }
      if (val == "出发日期" || val == "返回日期") {
        if (val == "出发日期") {
          if (this.addForm.leaveTime) {
            this.currentDate = new Date(this.addForm.leaveTime);
          } else {
            this.currentDate = new Date();
          }
        }
        if (val == "返回日期") {
          if (this.addForm.returnTime) {
            this.currentDate = new Date(this.addForm.returnTime);
          } else {
            this.currentDate = new Date();
          }
        }
        this.dateType = "date";
        this.selectDate = true;
      }
      if (
        val == "是否分摊" ||
        val == "是否行政相关" ||
        val == "是否通讯费相关" ||
        val == "是否冲借支"
      ) {
        this.showValue = "code";
        this.columns = [
          { code: "是", name: 1 },
          { code: "否", name: 0 },
        ];
      }
      if (val == "是否超标") {
        this.showValue = "code";
        this.columns = [
          { code: "是", name: 1 },
          { code: "否", name: 0 },
        ];
      }
      if (val == "招待性质") {
        this.showValue = "name";
        this.columns = this.zdArr;
        this.addIndex = delIndex;
      }
      if (val == "发生季度") {
        this.showValue = "code";
        this.columns = this.quarterArr;
        this.addIndex = delIndex;
      }
      if (val == "气温情况") {
        this.showValue = "code";
        this.columns = this.temperatureArr;
        this.addIndex = delIndex;
      }
      if (val == "费用发生(月份)") {
        this.dateType = "year-month";
        this.addIndex = delIndex;
        this.selectDate = true;
      }
      this.showTitle = val;
      if (val == "beginDate") {
        this.showTitle = "开始时间";
      }
      if (val == "endDate") {
        this.showTitle = "结束时间";
      }
      if (isShow) {
        this.show = true;
      }
    },
    add() {
      let obj = {};
      if (this.workflow == 0) {
        obj = {
          beginDate: new Date().toLocaleDateString().split("/").join("-"), //开始日期
          endDate: new Date().toLocaleDateString().split("/").join("-"), //结束日期
        };
      }
      if (this.workflow == 3 || this.workflow == 2) {
        obj = {
          occurTime: new Date().toLocaleDateString().split("/").join("-"), //发生日期
        };
      }
      this.currentDate = new Date();
      this.addForm.detailRequestList.push({
        add: true,
        delIndex: new Date().getTime(),
        department: this.info.department, //费用承担部门
        departmentCode: this.info.departmentCode, //费用承担部门编码
        costName: "", //费用类型
        ...obj,
        amount: "", //报销金额
        travelToolName: "", //出行工具
        // invoiceTypeName: "", //票据类型
        provenance: "", //始发地
        destination: "", //目的地
        costDescription: "", //费用说明
        invoiceTypeName: "", //发票类型
        invoiceNumber: "", //发票号码
        invoiceCode: "", //发票代码
        noTaxAmountStr: "", //发票不含税金额
        taxRate: "", //税率
        taxAmountStr: "", //税额
        totalAmountStr: "", //价税合计
      });
      this.$forceUpdate();
    },
    deleteItem(delIndex) {
      this.addForm.detailRequestList = this.addForm.detailRequestList.filter(
        (item,index) => index != delIndex
      );
      this.setRz()
      this.$forceUpdate();
    },
    getData() {
      this.$api
        .post("/payment/center/reimburse/getDetail", {
          reqData: {
            id: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.addForm = JSON.parse(JSON.stringify(res.repData));
            if (this.addForm.itinerary) {
              let arr = this.addForm.itinerary.split("-");
              console.log(arr);
              this.sf = arr[0];
              this.tjone = arr[1];
              this.tjtwo = arr[2];
              this.md = arr[3];
            }
            if (this.addForm.travelTypeName) {
              this.isGetData = 1;
              this.travelTypeCost = this.addForm.travelType;
            }
            if (this.addForm.isCommunication == 0)
              this.addForm.isCommunicationName == "否";
            if (this.addForm.isCommunication == 1)
              this.addForm.isCommunicationName == "是";
            if (this.addForm.isAdministrative == 0)
              this.addForm.isAdministrativeName == "否";
            if (this.addForm.isAdministrative == 1)
              this.addForm.isAdministrativeName == "是";
            if (res.repData.domesticVoList) {
              this.addForm.detailRequestList = res.repData.domesticVoList;
            }
            if (res.repData.cityVoList) {
              this.addForm.detailRequestList = res.repData.cityVoList;
            }
            if (res.repData.pettyVoList) {
              this.addForm.detailRequestList = res.repData.pettyVoList;
            }
            if (res.repData.businessVoList) {
              this.addForm.detailRequestList = res.repData.businessVoList;
            }
            if (res.repData.houseCarVoList) {
              this.addForm.detailRequestList = res.repData.houseCarVoList;
            }
            if (res.repData.phoneVoList) {
              this.addForm.detailRequestList = res.repData.phoneVoList;
            }
            if (res.repData.carVoList) {
              this.addForm.detailRequestList = res.repData.carVoList;
            }
            if (res.repData.welfareVoList) {
              this.addForm.detailRequestList = res.repData.welfareVoList;
            }
            if (res.repData.meetingVoList) {
              this.addForm.detailRequestList = res.repData.meetingVoList;
            }
            if (res.repData.mealVoList) {
              this.addForm.detailRequestList = res.repData.mealVoList;
            }
            if (res.repData.licenseVoList) {
              this.addForm.detailRequestList = res.repData.licenseVoList;
            }
            if (res.repData.loanList) {
              this.addForm.writeoffDetailEntityList = JSON.parse(JSON.stringify(res.repData.loanList));
            }
            if (!this.addForm.detailRequestList) {
              this.addForm.detailRequestList = [];
            }
            this.addForm.detailRequestList = JSON.parse(
              JSON.stringify(this.addForm.detailRequestList)
            );
            this.addForm.files = this.addForm.fileVoList;
            if (!this.addForm.files) {
              this.addForm.files = [];
            }
            this.addForm.detailRequestList = this.addForm.detailRequestList.map(
              (item,index) => {
                return {
                  ...item,
                  add: true,
                  delIndex: new Date().getTime() + index,
                };
              }
            );
            if (this.addForm.isExcess == 0) {
              this.addForm.excess = "否";
            }
            if (this.addForm.isExcess == 1) {
              this.addForm.excess = "是";
            }
            if (this.addForm.workflow == 1) {
              this.setBt("detail");
            }
            this.$forceUpdate();
          }
        });
    },
    selectClip() {
      this.$router.push({
        path: "/selectInvoice",
      });
    },
    async save(val) {
      if (this.$route.query.type == "edit") {
        this.addForm.isUpdate = true;
        this.addForm.id = this.$route.query.id;
      } else {
        this.addForm.isUpdate = false;
        this.addForm.id = "";
      }
      let obj = this.backList.find(
        (item) => item.label == this.addForm.payeeCombination
      );
      if (obj) {
        this.addForm.bankAccount = obj.bankAccount;
        this.addForm.bankName = obj.bankName;
        this.addForm.branchName = obj.branchName;
        this.addForm.regionCode = obj.regionCode;
        this.addForm.accountNum = obj.accountNum;
        this.addForm.accountNature = obj.nature;
        this.addForm.payeeProvince = obj.province;
        this.addForm.payeeCity = obj.city;
      }
      this.addForm.submit = val;
      let { flag, message } = saveObj.verify(this);
      if (!flag) {
        this.$toast(message);
        return;
      }
      if (this.addForm.workflow == 5) {
        this.addForm.detailRequestList.map((item) => {
          if (!item.escortsPerson) {
            item.escortsPerson = 0;
          }
        });
      }
      if (this.addForm.isExcess == 0) {
        this.addForm.excessApplyNum = "";
        this.addForm.excessApplyId = "";
        if (this.addForm.isExcess == 0) {
          this.addForm.excessApplyNum = "";
          this.addForm.excessApplyId = "";
        }
      }
      if (this.addForm.workflow != 0 && this.addForm.workflow != 4 && this.addForm.workflow != 13) {
        console.log(this.addForm.workflow, "开始");
        let params = {};
        if (this.addForm.workflow == 1 || this.addForm.workflow == 8) {
          params = {
            unitCode: this.addForm.unitCode,
            expenseDepartCode: this.addForm.expenseDepartCode,
            poststr: this.addForm.detailRequestList.map((item) => {
              return { costType: item.costType };
            }),
          };
          console.log(this.addForm.workflow, "来哦", params);
        }
        if (
          this.addForm.workflow == 2 ||
          this.addForm.workflow == 3 ||
          this.addForm.workflow == 5 ||
          this.addForm.workflow == 6 ||
          this.addForm.workflow == 7 ||
          this.addForm.workflow == 9 ||
          this.addForm.workflow == 10 ||
          this.addForm.workflow == 11 ||
          this.addForm.workflow == 12
        ) {
          params = {
            unitCode: this.addForm.unitCode,
            expenseDepartCode: this.addForm.expenseDepartCode,
            costType: this.addForm.costType,
          };
          console.log(this.addForm.workflow, "来哦", params);
        }
        this.saveLoading = true;
        let res = await this.$api.post(
          "/payment/center/reimburse/queryBudget",
          {
            reqData: params,
          }
        );
        if (res.repCode == "0000") {
          this.addForm.detailRequestList.map((item, index) => {
            item = {
              ...item,
              ...res.repData[index],
            };
          });
        }
      }
      this.$api
        .post("/payment/center/reimburse/insertOrUpdate", {
          reqData: {
            ...this.addForm,
          },
        })
        .then(async (res) => {
          if (res.repCode == "0000") {
            if (val) {
              if(this.addForm.workflow == 3 && this.addForm.isBorrow){
                let jzdRes = await this.$api
                .post("/payment/center/reimburse/haveNoZero", {
                  reqData: {
                    id: res.repData,
                  },
                })
                if(jzdRes.repCode === "0000"){
              
                  if(jzdRes.repData && jzdRes.repData.isNoZero === "1"){
                    Dialog.confirm({
                      title: '提示',
                      message:jzRes.repData.msg,
                    })
                      .then(() => {
                        this.$api
                          .post("/payment/center/reimburse/submit", {
                            reqData: {
                              id: res.repData,
                            },
                          })
                          .then((res2) => {
                            if (res2.repCode == "0000") {
                              this.$notify({
                                type: "success",
                                message: "操作成功",
                              });
                              if (this.type == "add") {
                                this.addForm.detailRequestList = [];
                                this.addForm.files = [];
                              }
                              if (this.type == "edit") {
                                this.getData();
                              }
                              this.$router.go(-1);
                            }
                            this.saveLoading = false;
                          })
                          .catch(() => {
                            this.saveLoading = false;
                          });
                      })
                      .catch(() => {
                      });
                    return
                  }
                }
              }
              this.$api
                .post("/payment/center/reimburse/submit", {
                  reqData: {
                    id: res.repData,
                  },
                })
                .then((res2) => {
                  if (res2.repCode == "0000") {
                    this.$notify({
                      type: "success",
                      message: "操作成功",
                    });
                    if (this.type == "add") {
                      this.addForm.detailRequestList = [];
                      this.addForm.files = [];
                    }
                    if (this.type == "edit") {
                      this.getData();
                    }
                    this.$router.go(-1);
                  }
                  this.saveLoading = false;
                })
                .catch(() => {
                  this.saveLoading = false;
                });
            } else {
              this.$notify({
                type: "success",
                message: "操作成功",
              });
              if (this.type == "add") {
                this.addForm.detailRequestList = [];
                this.addForm.files = [];
              }
              if (this.type == "edit") {
                this.getData();
              }
              this.$router.go(-1);
            }
          }else{
            this.saveLoading = false;
          }
        })
        .catch(() => {
          this.saveLoading = false;
        });
    },
    upload() {
      let ipt = document.createElement("input");
      ipt.type = "file";
      ipt.multiple = "multiple";
      ipt.click();
      ipt.onchange = () => {
        let params = new FormData();
        params.append("files", ipt.files[0], ipt.files[0].name);
        this.uploadLoading = true;
        this.$api
          .uploadPost(
            `/zuul/payment/center/upload/fileMultiple?token=${Cookies.get(
              "payapp_token"
            )}`,
            params
          )
          .then((res) => {
            this.uploadLoading = false;
            if (res.repCode == "0000") {
              let arr = res.repData.map((item) => {
                return {
                  filePath: item.attName,
                  fileName: item.fileName,
                };
              });
              if (this.addForm.files) {
                this.addForm.files = [...this.addForm.files, ...arr];
              } else {
                this.addForm.files = arr;
              }
              this.$forceUpdate();
            }
          })
          .catch(() => {
            this.uploadLoading = false;
          });
      };
    },
    deleteFj(index) {
      this.addForm.files = this.addForm.files.filter(
        (item, ind) => ind != index
      );
      this.$forceUpdate();
    },
    jump(path) {
      this.$router.push({
        path
      });
    },
    getCostList() {
      this.$api
        .post("/payment/center/expense/cost/getHoauCostList", {
          reqData: {
            workflow: this.addForm.workflow, //
            companyId: Cookies.get("payapp_companyId"),
            travelType: this.addForm.travelType,
            // companyId:184,
            pageNum: 1,
            pageRows: 10,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.costList = res.repData.list;
            if (
              this.addForm.workflow == 2 ||
              this.addForm.workflow == 5 ||
              this.addForm.workflow == 6 ||
              (this.addForm.workflow == 7 && res.repData.list.length)
            ) {
              this.addForm.costName = res.repData.list[0].costName;
              this.addForm.costType = res.repData.list[0].costCode;
            }
          }
        });
    },
    getList() {
      this.$api
        .post("/payment/center/hoau/dict/getAll", {
          reqData: {},
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.jobNames = res.repData.HOAU_WORKFLOW;
            this.currentList = res.repData.HOAU_CURRENCY;
            this.payTypeList = res.repData.HOAU_PAYWAY;
            this.travelType = res.repData.HOAU_TRAVEL_TYPE;
            this.toolList = res.repData.HOAU_TRAVEL_TOOL;
            this.paperList = res.repData.HOAU_INVOICE_TYPE;
            this.taxRateList = res.repData.HOAU_TAX_RATE;
            this.fjList = res.repData.HOAU_WORKFLOW_TEMPLATE;
            this.zdArr = res.repData.RECEPTNATURE001;
            this.quarterArr = res.repData.HOAU_OCCUR_QUARTER;
            this.temperatureArr = res.repData.HOAU_TEMPERATURE;
            this.jzList = res.repData.HOAU_LOAN_TYPE;
            this.meetingList = res.repData.HOAU_MEETING_TYPE.map((item) => {
              return {
                ...item,
                name: Number(item.name),
              };
            });
          }
        });
      this.$api
        .post("/payment/center/reimburse/getList", {
          reqData: {},
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.advanceApplyList = res.repData.list;
            // this.total = res.repData.total;
          }
        });
      this.$api
        .post("/payment/center/employeeBank/getList", {
          reqData: {},
        })
        .then((res) => {
          if (res.repCode == "0000") {
            if (!res.repData.result) {
              return;
            }
            this.backList = res.repData.result.map((item) => {
              if (item.isDefault && this.$route.query.type == "add") {
                this.addForm.payeeCombination =
                  item.bankAccount +'/'+ item.bankName + item.branchName + '/' + item.accountNum;
                this.addForm.bankAccount = item.bankAccount;
                this.addForm.bankName = item.bankName;
                this.addForm.branchName = item.branchName;
                this.addForm.regionCode = item.regionCode;
                this.addForm.accountNum = item.accountNum;
                this.addForm.accountNature = item.nature;
                this.addForm.payeeProvince = item.province;
                this.addForm.payeeCity = item.city;
              }
              return {
                ...item,
                label: item.bankAccount +'/'+ item.bankName + item.branchName + '/' + item.accountNum,
              };
            });
            this.$forceUpdate();
          }
        });
      this.$api
        .post("/payment/center/department/queryByAccountModeId", {
          reqData: {
            accountModeId: Cookies.get("payapp_companyId"),
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.departmentList = res.repData.department;
          }
        });
    },
    getInfo() {
      this.$api
        .post("/payment/center/hoau/employee/getInfo", {
          reqData: {},
        })
        .then((res) => {
          if (res.repCode == "0000") {
            if (!res.repData) {
              return;
            }
            this.info = res.repData;
            this.addForm.salaryCompany = res.repData.salaryCompany;
            this.addForm.department = res.repData.department;
            this.addForm.departmentCode = res.repData.departmentCode;
            this.addForm.expenseDepartName = res.repData.department;
            this.addForm.expenseDepartCode = res.repData.departmentCode;
            this.addForm.financeName = res.repData.financeName;
            this.addForm.financeId = res.repData.financeId;
            this.addForm.financeCode = res.repData.financeCode;
            this.addForm.employeeName = res.repData.employeeName;
            this.addForm.employeeCode = res.repData.employeeCode;
            this.addForm.positionName = res.repData.positionName;
            this.addForm.costClassification = res.repData.costClassification;
            this.addForm.budgetUnit = res.repData.budgetUnit;
            this.addForm.unitCode = res.repData.unitCode;
            this.addForm.levelExplain = res.repData.levelExplain;
            this.$forceUpdate();
          }
        });
    },
  },
};
</script>

<style lang="scss">
.travelBx {
  height: 100%;
  padding-top: 6px;
  .van-swipe{
    background: #fff;
  }
  // .van-picker{
  //   height: 100%;
  //   display: flex;
  //   flex-direction: column;
  //   // .van-picker__columns{
  //   //   flex: 1;
  //   // }
  // }
  .van-cell__title {
    span {
      font-size: 14px;
      color: #000;
    }
  }
  .jg {
    height: 6px;
  }
  .workflow {
    div {
      font-size: 13px;
      margin: 4px 0;
    }
    span {
      color: #323233;
    }
  }
  .essentialInformation {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 50%;
      flex-shrink: 0;
      flex-wrap: 0;
      display: flex;
      align-items: center;
      div {
        width: 50%;
        margin: 10px 0;
      }
      .label {
        display: flex;
        justify-content: flex-end;
        font-size: 13px;
        color: rgb(109, 113, 132);
      }
      .text {
        color: rgb(44, 44, 44);
        padding-left: 10px;
        font-size: 13px;

      }
    }
  }
  .gridBox {
    .van-grid-item {
      width: 50% !important;
      overflow: hidden;
      position: static !important;
    }
    // background: #fff;
    .tabContro {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      font-size: 14px;
      background: #fff;
      .tit {
        color: rgb(109, 113, 132);
      }
      .del {
        color: red;
      }
    }
    .title {
      font-size: 14px;
      color: rgb(109, 113, 132);
      margin-bottom: 4px;
    }
    .van-cell {
      padding: 0 0 !important;
    }
    .van-field__control::placeholder {
      color: rgb(155, 159, 171) !important;
    }
    .item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 10px;
      .van-cell {
        padding: 0 0 !important;
      }
      .van-cell__value--alone {
        color: rgb(155, 159, 171);
        overflow: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
      }
    }
  }
  .van-tabs__line {
    width: calc(100% / 3);
  }
  .btnBox {
    padding: 10px 20px;
    background: #fff;
    button {
      width: 100%;
      border-radius: 5px;
      background: rgb(58, 117, 197);
      font-size: 12px;
    }
  }
  .add {
    padding: 10px 0;
    button {
      width: 100%;
      border-radius: 5px;
      background: #fff;
      font-size: 12px;
    }
  }
}
</style>